import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/border.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/animations/shift-away.css';
import Tippy from '@tippyjs/react';
import { Image } from 'components/Image/Image';
import { MouseEvent } from 'react';

type Props = {
  content: string;
  label?: string;
};

const getPaymentOptionPopupLabel = (benefitHtml: string) => {
  const fallbackText = benefitHtml.replace(/<[^>]*>/g, ' ');
  const element =
    typeof document === 'undefined' ? null : document.createElement('span');

  if (element) element.innerHTML = benefitHtml;

  const benefitText = (element?.textContent || fallbackText)
    .replace(/\s+/g, ' ')
    .trim();

  return benefitText
    ? `More information about ${benefitText}`
    : 'Payment option information';
};

const PaymentOptionPopup = ({
  content,
  label = 'Payment option information',
}: Props) => {
  const stopCardSelection = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
  };

  return (
    <Tippy
      className="tooltip"
      theme="light-border"
      animation="shift-away"
      maxWidth={370}
      arrow={true}
      duration={200}
      delay={[75, 0]}
      content={
        <div className="bg-light-600">
          <p className="sm:hidden absolute top-0 right-0 cursor-pointer">x</p>
          <p
            className="text-center"
            style={{ whiteSpace: 'break-spaces' }}
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          ></p>
        </div>
      }
    >
      <button
        type="button"
        aria-label={label}
        onClick={stopCardSelection}
        className="inline-block ml-0.5 align-middle relative top-px appearance-none border-0 bg-transparent p-0 rounded-sm cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-900"
      >
        <div className="w-4 h-4 font-bold flex justify-center items-center -top-0.5 left-0.5 md:left-[unset] relative">
          <Image path="booking/icons/info.svg" alt="info icon" />
        </div>
      </button>
    </Tippy>
  );
};

export { getPaymentOptionPopupLabel, PaymentOptionPopup };
